import { ShapeBaseAttribute } from './base';

export class VideoWatchfaceAttribute extends ShapeBaseAttribute {
  // 单个视频资源
  /**
   * 重复次数
   */
  repeatCount = 1;

  /**
   * 是否重复播放
   */
  infinite = false;

  /**
   * Video资源src
   */
  videoSrc?: string;

  /**
   * Video资源名称
   */
  videoName?: string;

  /**
   * Video帧率
   */
  videoFps?: number;
}
